import moment from 'moment';
import EntityModel from '@/common/models/entity-model';

const weekDaysList = moment.weekdays();

export default class PeriodAnchorInstructionModel extends EntityModel {
    static PeriodAnchorMethods = {
        // immediately: 'immediately',
        dayOfMonth: 'day-of-month',
        dayOfWeek: 'day-of-week',
    };

    static PeriodWeekTypes = {
        next: 'next',
        firstInMonth: 'first-in-month',
        lastInMonth: 'last-in-month',
    };

    static prepareInstruction(periodAnchorInstruction) {
        const {
            method, day, week, time,
        } = periodAnchorInstruction;

        // default data
        const instruction = {
            method,
        };

        switch (periodAnchorInstruction.method) {
            // prepare immediately
            case PeriodAnchorInstructionModel.PeriodAnchorMethods.immediately: {
                return instruction;
            }
            // prepare dayOfMonth
            case PeriodAnchorInstructionModel.PeriodAnchorMethods.dayOfMonth: {
                // validate day value
                if (day && (isNaN(day) || day <= 0 || day > 31)) {
                    throw new Error(`Invalid day ${day}`);
                }
                return {
                    ...instruction,
                    day, // required
                    time,
                };
            }
            // prepare dayOfWeek
            case PeriodAnchorInstructionModel.PeriodAnchorMethods.dayOfWeek: {
                // validate day value
                if (!weekDaysList.includes(day)) {
                    throw new Error(`Invalid day ${day}`);
                }
                // validate week value
                if (periodAnchorInstruction.week
                    && !Object
                        .values(PeriodAnchorInstructionModel.PeriodWeekTypes)
                        .includes(week)) {
                    throw new Error(`Invalid week type ${week}`);
                }
                return {
                    ...instruction,
                    day, // required
                    week,
                    time,
                };
            }
            default:
                throw new Error(`Please implement prepare for ${periodAnchorInstruction.method}`);
        }
    }

    hydrate({
        method = null,
        day = null,
        week = null,
        time = null,
    } = {}) {
        const instruction = PeriodAnchorInstructionModel.prepareInstruction({
            method, day, week, time,
        });
        this.method = instruction.method || null;
        this.day = instruction.day || null;
        this.week = instruction.week || null;
        this.time = instruction.time || null;
    }

    getPayload() {
        const periodAnchorInstruction = PeriodAnchorInstructionModel
            .prepareInstruction(this);

        if (periodAnchorInstruction.time) {
            periodAnchorInstruction.time = periodAnchorInstruction.time
                .format(PeriodAnchorInstructionModel.timeAPIFormat);
        }
        return {
            ...periodAnchorInstruction,
        };
    }
}
